import React from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { routes } from './Routes';
import Layout from '../Themes/Layout/Layout';

const LayoutRoutes = () => {
  const location = useLocation();
  const element = useRoutes(
    routes.map(({ path, Component }) => ({ path, element: Component })),
    location,
  );

  if (!element) {
    return null;
  }

  return <Layout>{element}</Layout>;
};

export default LayoutRoutes;
